<style lang="scss">
  @use "../../../../../assets/css/global.scss" as *;
  @use "../../../../../assets/css/_colors.scss" as *;
  @use "../Components/TrainingHubMixins.scss" as *;
  div {
    position: relative;
    top: 1.8rem;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    background-color: #fff;
    font-size: 1.5rem;

    @include training-hub-locked();

    &.completed {
      background: #fff;
      color: $turquoise;
    }

    &.locked {
      background: #fff;
      color: #8c8c8c;
      opacity: 0.7;
    }

    &.current {
      position: relative;

      svg {
        position: absolute;
      }

      svg g circle {
        transform-origin: center;
        animation: blink 2s infinite;
      }
    }

    &.pending {
      background: transparent;
      color: #fff;
    }

    .pending-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background-color: $orange;
      border-radius: 50%;

      i {
        font-size: 14px;
      }
    }

    .fa-circle {
      color: $secondary-border-color;
    }

    @keyframes blink {
      0% {
        opacity: 0;
        transform: scale(1);
      }
      50% {
        transform: scale(1.4);
        opacity: 1;
      }
      100% {
        transform: scale(2);
        opacity: 0;
      }
    }

    @keyframes checkmark-animation {
      0% {
        transform: none;
        opacity: 0;
      }
      50% {
        transform: scale3d(1.2, 1.2, 1.2);
        opacity: 1;
      }
      100% {
        transform: none;
      }
    }
    &.lastCompleted {
      animation: checkmark-animation 1s ease-in-out forwards;
      position: relative;

      &:before {
        position: absolute;
        background-color: $turquoise;
        width: 60%;
        height: 60%;
        top: 20%;
        right: 20%;
        transform: rotate(-45deg);
        content: "";

        @keyframes uncover {
          0% {
            width: 60%;
            top: 20%;
          }
          100% {
            width: 0;
            top: 10%;
          }
        }
        animation: uncover 0.5s linear forwards;
      }
    }
  }
</style>

<script>
  export let status;
  export let lastCompleted = false;
</script>

<div
  class:completed={status === "completed"}
  class:locked={status === "locked"}
  class:current={status === "current"}
  class:pending={status === "pending"}
  class:lastCompleted
>
  {#if status === "completed"}
    <i class="fa-solid fa-circle-check"></i>
  {:else if status === "locked"}
    <i class="fa-solid fa-lock"></i>
  {:else if status === "current"}
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      class="current-task-svg"
    >
      <g>
        <circle cx="22" cy="22" r="11" fill="#44d5c8"></circle>
      </g>
      <circle
        cx="22"
        cy="22"
        r="11"
        fill="#fff"
        stroke="#44d5c8"
        stroke-width="2"
      ></circle>
    </svg>
  {:else if status === "pending"}
    <span class="pending-icon-wrapper">
      <i class="fa-regular fa-clock"></i>
    </span>
  {:else}
    <i class="fa-regular fa-circle"></i>
  {/if}
</div>
